import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "FileUpload" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
